(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-ugc-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ugc-carousel')) {
    customElements.define('ugc-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ugc-track]');
        this.slides = Array.from(this.querySelectorAll('[data-ugc-slide]'));
        this.copies = Array.from(this.querySelectorAll('[data-ugc-copy]'));
        this.dots = Array.from(this.querySelectorAll('[data-ugc-dot]'));
        this.activeIndex = 0;
        this.inView = false;
        this.lockUntil = 0;
        this.drag = null;

        if (!this.track || !this.slides.length) return;

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.onPrev = () => this.goTo(this.activeIndex - 1, true);
        this.onNext = () => this.goTo(this.activeIndex + 1, true);
        this.querySelector('[data-ugc-prev]')?.addEventListener('click', this.onPrev);
        this.querySelector('[data-ugc-next]')?.addEventListener('click', this.onNext);
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.ugcDot))));
        this.slides.forEach((slide, index) => slide.addEventListener('click', () => {
          if (!this.dragged && index !== this.activeIndex) this.goTo(index);
        }));

        this.onScroll = () => {
          if (this.raf) return;
          this.raf = window.requestAnimationFrame(() => {
            this.raf = null;
            if (Date.now() < this.lockUntil) return;
            this.updateActiveFromScroll();
          });
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.onKeydown = (event) => {
          if (event.key === 'ArrowRight') { event.preventDefault(); this.goTo(this.activeIndex + 1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.goTo(this.activeIndex - 1); }
        };
        this.track.addEventListener('keydown', this.onKeydown);

        this.bindMouseDrag();

        this.observer = new IntersectionObserver((entries) => {
          this.inView = entries.some((entry) => entry.isIntersecting);
          this.syncVideos();
        }, { threshold: 0.25 });
        this.observer.observe(this);

        this.onBlockSelect = (event) => {
          const target = event.target;
          let index = this.slides.findIndex((slide) => slide.contains(target));
          if (index < 0) index = this.copies.findIndex((copy) => copy === target || copy.contains(target));
          if (index > -1) this.goTo(index);
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        this.setActive(0);
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.track?.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.observer?.disconnect();
        window.cancelAnimationFrame(this.raf);
        this.slides?.forEach((slide) => slide.querySelector('video')?.pause());
      }

      /* Masaüstünde fare ile sürükleyerek kaydırma (dokunmatikte yerel kaydırma kullanılır) */
      bindMouseDrag() {
        this.dragged = false;
        this.track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.drag = { x: event.clientX, left: this.track.scrollLeft, moved: false };
        });
        window.addEventListener('pointermove', this.onPointerMove = (event) => {
          if (!this.drag) return;
          const dx = event.clientX - this.drag.x;
          if (!this.drag.moved && Math.abs(dx) < 5) return;
          if (!this.drag.moved) { this.drag.moved = true; this.track.classList.add('is-dragging'); }
          this.track.scrollLeft = this.drag.left - dx;
        });
        window.addEventListener('pointerup', this.onPointerUp = () => {
          if (!this.drag) return;
          const moved = this.drag.moved;
          this.drag = null;
          if (!moved) return;
          this.dragged = true;
          window.setTimeout(() => { this.dragged = false; }, 0);
          this.track.classList.remove('is-dragging');
          this.updateActiveFromScroll();
          this.goTo(this.activeIndex);
        });
      }

      updateActiveFromScroll() {
        const left = this.track.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Infinity;
        this.slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - left);
          if (distance < closestDistance) { closestDistance = distance; closestIndex = index; }
        });
        this.setActive(closestIndex);
      }

      goTo(index, wrap = false) {
        const last = this.slides.length - 1;
        if (index < 0) index = wrap ? last : 0;
        if (index > last) index = wrap ? 0 : last;
        const slide = this.slides[index];
        if (!slide) return;
        this.lockUntil = Date.now() + 700;
        this.track.scrollTo({ left: slide.offsetLeft, behavior: this.reduceMotion.matches ? 'auto' : 'smooth' });
        this.setActive(index);
      }

      setActive(index) {
        if (Number.isNaN(index) || !this.slides[index]) return;
        this.activeIndex = index;

        this.slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
        this.copies.forEach((copy, copyIndex) => copy.classList.toggle('is-hidden', copyIndex !== index));
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
        this.syncVideos();
      }

      /* Yalnızca ekrandaki bölümde ve aktif kartta oynat */
      syncVideos() {
        const canPlay = this.dataset.autoplay === 'true' && this.inView && !this.reduceMotion.matches;
        this.slides.forEach((slide, slideIndex) => {
          const video = slide.querySelector('video');
          if (!video) return;
          if (canPlay && slideIndex === this.activeIndex) video.play().catch(() => {});
          else video.pause();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
